import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function SidebarButton({
	children,
	className,
	name,
	logoutBtn,
	setShowSidebar,
	...props
}) {
	const navigate = useNavigate();
	const location = useLocation();

	return (
		<button
			className={`
            flex items-center 
            px-3 py-2
            my-1
			text-sm 3xl:text-base
            border-l-4 rounded
            hover:text-main 
            hover:bg-bg
			focus:outline-none
			capitalize
            duration-200 ease-in-out
            ${
							location.pathname.includes("/" + name.replaceAll(" ", ""))
								? "border-main text-main bg-bg"
								: "border-transparent text-dark"
						}
            ${className}
			`}
			onClick={() => {
				setShowSidebar(false);

				if (logoutBtn === true) {
					return;
				}
				navigate("/" + name.replaceAll(" ", ""));
			}}
			{...props}
		>
			{children}&nbsp; {name}
		</button>
	);
}
